module.exports = __webpack_public_path__ + "img/measurement_info_back_feet_left.0b6d478c.jpg";